const debounce = require('debounce');

require('../customer/components/mobileMenu');
// require('../customer/components/headerCountdown');
require('../customer/components/menuAim')

function activateSubmenu(row) {
    var $row = $(row),
        submenuId = $row.attr("data-submenuId"),
        $submenu = $("#" + submenuId);

    // Show the submenu
    $submenu.css({
        display: "block"
    });

    // Keep the currently activated row's highlighted look
    $row.addClass("maintainHover");
}

function deactivateSubmenu(row) {
    var $row = $(row),
        submenuId = $row.attr("data-submenuId"),
        $submenu = $("#" + submenuId);

    // Hide the submenu and remove the row's highlighted look
    $submenu.css("display", "none");
    $row.removeClass("maintainHover");
}

$('.submenu_list').menuAim({
    activate: activateSubmenu,
    deactivate: deactivateSubmenu,
    exitMenu: () => true
});

$('.nav-items .shopmenu').on('mouseleave', function () {
    const elements = $('.maintainHover');
    elements.each(element => {
        const id = $(element).attr('data-submenuId');
        $(`#${id}`).css("display", "none");
    });
    $('.maintainHover').removeClass('maintainHover');
})

$('.js-toggle-search').hide();

$('.js-toggle-search').on('click', function (e) {
    $('.header-sticky-bottom').slideToggle();
});

const checkScrollSpeed = ((checkDelay = 50) => {

    let lastPos, newPos, timer, delta,
        delay = checkDelay; // in "ms" (higher means lower fidelity )

    const clear = () => {
        lastPos = null;
        delta = 0;
    }

    clear();

    return () => {
        newPos = window.scrollY;
        if (lastPos != null) {
            delta = newPos - lastPos;
        }
        lastPos = newPos;
        clearTimeout(timer);
        timer = setTimeout(clear, delay);
        return delta;
    };
})();

function is_touch_device() {
    return 'ontouchstart' in window;
}

if (is_touch_device()) {
    $('.header-mobile').removeClass('hidden-lg');
    $('.js-header').removeClass('visible-lg').addClass('hidden');
} 
$(window).on('scroll', debounce(() => {
    const speed = checkScrollSpeed(),
        goingUp = (Math.sign(speed) == -1 ? true : false),
        goingStationary = (Math.sign(speed) == 0 ? true : false),
        goingDown = !goingUp;
    
    if (!$('.menuBackdrop').hasClass('_show')) {

        if ($(window).scrollTop() < 35) {
            if ($('.is_in_checkout').length == 0) {
                if (window.innerWidth < 1025 || is_touch_device()) {
                    $('.header-mobile').css('top', '1.75rem').css('height', 'unset');
                }
            }
            $('.header-top-nav').fadeIn();
    
            if (!$('.header-sticky').hasClass('not-scrolled')) {
                $('.header-sticky, body').removeClass('scrolled');
                $('.header-sticky, body').addClass('not-scrolled');
            }
        }
        if ($(window).scrollTop() >= 35 && (goingDown)) {

            if ($('.is_in_checkout').length == 0) {
                if (window.innerWidth < 1200 || is_touch_device())
                    $('.header-mobile').css('top', '0').css('height', 'unset');
                else
                    $('.header').css('top', '0');
            }
            $('.header-top-nav').fadeOut();
            if ($('.header-sticky').hasClass('not-scrolled')) {
                $('.header-sticky, body').removeClass('not-scrolled');
                $('.header-sticky, body').addClass('scrolled');
            }
        }
    }
}), 200, false);

// Toggle Header Categories when scrolling
const nav = document.querySelector('.header-sticky .main-nav');
const pdpSticky = document.querySelector('[data-js="pdp-sticky-orderform"]');
const scrollUp = "scroll-up-none"; //renamed to not use the css class
const scrollDown = "scroll-down-none"; //renamed to not use the css class
let lastScroll = 0;

function checkPosition() {
    if (!document.querySelector('.menuBackdrop').classList.contains('_show')) {
        let currentScroll = window.scrollY;;
        if (currentScroll <= 35) {
            nav.classList.remove(scrollUp);

            if (pdpSticky) {
                pdpSticky.style.top = '0px';
            }

            return;
        }
        if (currentScroll > lastScroll && !(nav.classList.contains(scrollDown)) ) {
            // down
            nav.classList.remove(scrollUp);
            nav.classList.remove('visible-not-scrolled');
            nav.classList.add(scrollDown);

            if (pdpSticky) {
                pdpSticky.style.removeProperty("top");
            }

        } else if (currentScroll < lastScroll && nav.classList.contains(scrollDown)) {
            const weblayer = document.querySelector('.weblayer--bar-countdown');
            
            // up
            nav.classList.add(scrollUp);
            nav.classList.remove(scrollDown);

            if (pdpSticky) {
                if (weblayer) {
                    const totalHeight = weblayer.clientHeight + 138;
                    pdpSticky.style.top = totalHeight+'px';

                } else {
                    pdpSticky.style.top = '138px';
                }
            }
        }

        lastScroll = currentScroll;
        return;
    }
}

if (document.body.clientWidth > 1200) {
    window.addEventListener('scroll', debounce(checkPosition), 1);
}

// Show backdropon hover menu items
function DropdownMenu() {
    const backDrop = document.querySelector('.menuBackdrop');
	const navbar_nav = document.querySelector('.js-navbar');
    
    document.addEventListener("mouseover", (e) => {
        const target = e.target.matches('.btn-shop');
        const classNames = ['dlist', 'active'];

        if (target) {
            const selector = e.target;
            if (classNames.some(className => selector.classList.contains(className))) {
                backDrop.classList.add('_show');
            } else {
                backDrop.classList.remove('_show');
            }
        }
    });

    navbar_nav.addEventListener("mouseleave", (e) => {
        setTimeout(() => {
            backDrop.classList.remove('_show');
        }, 500);
    });
}

function closeMenu() {
    const close = document.querySelectorAll('[data-js="close-menu"]');
    const backdrop = document.querySelector('.menuBackdrop');

    close.forEach( item => {
        item.addEventListener('click', () => {
            const parent = item.closest('.shopmenu');
            parent.querySelector('.btn-shop').classList.remove('active');
            backdrop.classList.remove('_show');
        });
    });
}

closeMenu();

DropdownMenu();
